import { useEffect, useRef, useState } from "react";
import { Camera, FileText, Truck } from "lucide-react";

const steps = [
  { icon: Camera, num: "1", title: "Show Us What You've Got", desc: "Tell us what needs removing or send us a few photos." },
  { icon: FileText, num: "2", title: "Get Your Quote", desc: "We'll confirm the price and organise your pickup." },
  { icon: Truck, num: "3", title: "We Clear It", desc: "Our team does the lifting, loading and removal." },
];


const HowItWorks = () => {
  const gridRef = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = gridRef.current;
    if (!el || revealed) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [revealed]);

  return (
  <section id="how-it-works" className="scroll-mt-28 bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        How It Works
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Three simple steps. Then it's gone.
      </p>

      <div ref={gridRef} className="relative grid md:grid-cols-3 gap-10 max-w-4xl mx-auto">
        {/* Subtle connecting line (desktop only), behind the icons, aligned to
            the vertical centre of the 80px icon circles. z-0 keeps it above the
            white section bg but below the z-10 step cards/icons. */}
        <span
          aria-hidden="true"
          className="hidden md:block absolute left-[16.6667%] right-[16.6667%] top-[39px] z-0 pointer-events-none"
          style={{ height: "2px", background: "rgba(0,0,0,0.18)" }}
        />
        {steps.map((s, i) => (
          <div
            key={s.num}
            className="hiw-step relative z-10 h-full flex flex-col items-center text-center px-2"
            data-revealed={revealed ? "true" : "false"}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="hiw-icon w-20 h-20 bg-orange rounded-full ring-4 ring-yellow/30 flex items-center justify-center mb-5">
              <s.icon className="w-9 h-9 text-white" />
            </div>
            <h3 className="hiw-title text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <a
          href="/#quote"
          className="inline-block bg-[#1a1a1a] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange transition-colors"
        >
          Get Started. It's Free
        </a>
      </div>
    </div>
  </section>
  );
};

export default HowItWorks;
